export default {
  "en-US": () => import("./en-US.json"),
  "en-CA": () => import("./en-CA.json"),
  "en-GB": () => import("./en-GB.json"),
};
